import { useState } from "react";
import { useParams } from "react-router-dom";

const useAdd = () => {
  const { action } = useParams();
  const [currentTab, setCurrentTab] = useState<string>("1");

  const onTabChange = (value: string) => {
    setCurrentTab(value);
  };

  const onNextClick = () => {
    setCurrentTab((Number(currentTab) + 1).toString());
  };

  return {
    action,
    currentTab,
    onTabChange,
    onNextClick,
  };
};

export default useAdd;
